import React, { Fragment } from 'react';
import Modal from 'react-modal';
import Sticky from 'react-stickynode';
import { Helmet } from 'react-helmet';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { BarLoader } from 'react-spinners';
import Header from './Header';
import Hero from './Hero';
import MainProducts from './MainProducts';
import Footer from './Footer';
import Toast from './Toast';
import { slugify } from '../helpers';
import * as actionCreators from '../actions/actionCreators';

class Product extends React.Component {
  constructor(props) {
    super(props);

    // Slug
    this.slug = this.props.match.params.productId.toString().toLowerCase();

    // Give industries an array of sector IDs for hook
    this.sects = this.props.industries
      .map((indus, i) => indus.sectors)
      .reduce((prev, curr) => prev.concat(curr), []);

    this.state = {
      isGuideOpen: false,
      isFilterOpen: false,
      isAppetiteAccordionOpen: false,
      isResourcesAccordionOpen: false,
      width: window.innerWidth,
      isInterior: true,
    };

    this.toggleGuide = this.toggleGuide.bind(this);
    this.toggleFilter = this.toggleFilter.bind(this);
    this.toggleAppetiteAccordion = this.toggleAppetiteAccordion.bind(this);
    this.toggleResourcesAccordion = this.toggleResourcesAccordion.bind(this);
  }

  // Open User Guide/add blur
  toggleGuide() {
    this.setState({
      isGuideOpen: !this.state.isGuideOpen,
    });
  }

  toggleFilter() {
    this.setState({
      isFilterOpen: !this.state.isFilterOpen,
    });
  }

  toggleAppetiteAccordion() {
    this.setState({
      isAppetiteAccordionOpen: !this.state.isAppetiteAccordionOpen,
    });
  }

  toggleResourcesAccordion() {
    this.setState({
      isResourcesAccordionOpen: !this.state.isResourcesAccordionOpen,
    });
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
    this.product = this.props.products.find(product => {
      const san = slugify(product.name);
      if (san === this.slug) {
        const i = this.props.appetites.filter(appetite => appetite.productId === product.id);
        const appetite = this.props.appetites[i];
        this.name = product.name;
        this.productId = product.id;
        this.plate = i;
      }
    });
  }

  componentDidMount() {
    const tmp = this;
    setTimeout(() => {
      tmp.loadData();
    }, 2000);
  }

  loadData() {
    // Slug
    this.slug = this.props.match.params.productId.toString().toLowerCase();

    // Give industries an array of sector IDs for hook
    this.sects = this.props.industries
      .map((indus, i) => indus.sectors)
      .reduce((prev, curr) => prev.concat(curr), []);

    this.product = this.props.products.find(product => {
      const san = slugify(product.name);
      const tmp = this;
      if (san === this.slug) {
        const i = this.props.appetites.filter(appetite => appetite.productId === product.id);
        const appetite = this.props.appetites[i];
        this.name = product.name;
        this.productId = product.id;
        this.plate = i;
      }
    });
    this.setState({
      product: this.product,
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    const { width, isInterior, isAppetiteAccordionOpen, isResourcesAccordionOpen } = this.state || {};
    const isMobile = width <= 767;

    const {
      toggleGuide,
      toggleFilter,
      toast,
      isGuideOpen,
      isFilterOpen,
      closeModal,
      modalIsOpen,
      bookmarkPage,
      showInstallBanner,
    } = this.props;

    return (
      <Fragment>
        <Helmet>
          <title>{`Chubb CI - ${this.name}`}</title>
          <meta property="og:title" content={`Chubb CI - ${this.name}`} />
          <meta property="og:url" content={window.location} />
          <meta name="twitter:title" content={`Chubb CI - ${this.name}`} />
          <meta name="twitter:url" content={window.location} />
          <link rel="canonical" href={window.location} />
        </Helmet>
        <Sticky enabled top={0} offset={100}>
          <Header
            toggleGuide={toggleGuide}
            isGuideOpen={isGuideOpen}
            closeModal={closeModal}
            modalIsOpen={modalIsOpen}
            guide="User Guide"
            bookmarkPage={bookmarkPage}
          />
          <Hero {...this.props} heading={this.name} isInterior={isInterior} />
        </Sticky>
        <MainProducts
          {...this.props}
          plate={this.plate}
          product={this.productId}
          links={this.links}
          isGuideOpen={isGuideOpen}
          toggleFilter={toggleFilter}
          isFilterOpen={isFilterOpen}
          isAppetiteAccordionOpen={isAppetiteAccordionOpen}
          isResourcesAccordionOpen={isResourcesAccordionOpen}
          toggleAppetiteAccordion={this.toggleAppetiteAccordion}
          toggleResourcesAccordion={this.toggleResourcesAccordion}
        />
        <Footer feedback="Feedback" />
        {showInstallBanner && <Toast toast={toast} />}
      </Fragment>
    );
  }
}

export default Product;



// WEBPACK FOOTER //
// ./src/components/Product.js